import {Injectable, Type} from '@angular/core';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AbstractModal} from '../models/abstract-modal';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(private ngbModal: NgbModal) { }

  openModal(component: Type<AbstractModal>, options?: any): NgbModalRef {
    return this.ngbModal.open(component, options || {backdrop: true, size: 'fullscreen' as any});
  }
}
